import { capitalCategoricalPalette } from "../../capitalCategoricalPalette.js";
const MuiGauge = {
  styleOverrides: {
    valueArc: {
      fill: capitalCategoricalPalette[0]
    }
  }
};
export {
  MuiGauge
};
//# sourceMappingURL=MuiGauge.js.map
